module.exports = require('./input')

module.exports.PublicKey = require('./publickey')
module.exports.PublicKeyHash = require('./publickeyhash')
module.exports.MultiSig = require('./multisig.js')
module.exports.MultiSigScriptHash = require('./multisigscripthash.js')
